/**
 * Weather entry.
 */

// JS Component Framework and component configurations.
import { ComponentManager } from 'js-component-framework';
import weatherCurrentConfig from 'components/weather-current';
import weatherTimelineConfig from 'components/weather-timeline';
import weatherTabsConfig from 'components/weather-tabs';
import domContentLoaded from 'utils/domContentLoaded';

const componentManager = new ComponentManager('nexstar');
const initComponents = () => {
  componentManager.initComponents([
    weatherCurrentConfig,
    weatherTimelineConfig,
    weatherTabsConfig,
  ]);
};

// Initialize components.
domContentLoaded(() => {
  initComponents();
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR.
  initComponents();
}
